import pkg from '../package.json';

export * from './lib/index';
export const packageVersion = pkg.version;
